// Absichten: was der Spieler in diesem Tick will. Der Client baut je Tick eine Absicht aus
// Tastatur und Maus, die Simulation wendet sie auf den Zustand an; später prüft der Server
// dieselben Absichten (Architektur-Regel 3). Reine Daten, keine Logik.

export interface Intent {
  /** 1 vorwärts, -1 rückwärts, 0 nichts. */
  forward: -1 | 0 | 1;
  /** 1 nach rechts, -1 nach links, 0 nichts. */
  strafe: -1 | 0 | 1;
  /** Drehung um die Hochachse in diesem Tick, im Bogenmaß; positiv dreht nach links. */
  lookYaw: number;
  /** Neigung des Blicks in diesem Tick, im Bogenmaß; positiv nach oben. */
  lookPitch: number;
  /** Springen; wirkt nur am Boden und nicht beim Fliegen. */
  jump: boolean;
  /** Fliegen ein- bzw. ausschalten (Flanke, kein Halten). */
  toggleFly: boolean;
  /** Beim Fliegen aufwärts. */
  up: boolean;
  /** Beim Fliegen abwärts. */
  down: boolean;
  /** Die erste verfügbare Handlung am Ziel im Blick ausführen. */
  interact: boolean;
}

/** Eine Absicht, die nichts tut; jeder Aufruf liefert ein eigenes Objekt. */
export function emptyIntent(): Intent {
  return {
    forward: 0,
    strafe: 0,
    lookYaw: 0,
    lookPitch: 0,
    jump: false,
    toggleFly: false,
    up: false,
    down: false,
    interact: false,
  };
}
